import { render, staticRenderFns } from "./TemplateSubmission.vue?vue&type=template&id=1cff466d&"
import script from "./TemplateSubmission.vue?vue&type=script&lang=ts&"
export * from "./TemplateSubmission.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSubmission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports